export default __webpack_public_path__ + "static/growth-engine-logo-ef5a872905b4f5d81bacdd9fe84367d4.png";